<script setup lang="ts">
const { isLoggedIn } = useAccount();
const { siteOptions } = useSiteOptions();
</script>

<template>
  <a :href="isLoggedIn ? siteOptions.logout_url : siteOptions.login_url" class="auth-link">
    {{ isLoggedIn ? "Déconnexion" : "Connexion" }}
  </a>
</template>
